import { createFileRoute, redirect } from '@tanstack/react-router'
import { homePath } from '@/nav/navigation'

// `/` leitet je nach Rechten auf die passende Rollen-Startseite.
export const Route = createFileRoute('/_app/')({
  beforeLoad: ({ context }) => {
    throw redirect({ to: homePath(context.me.permissions), replace: true })
  },
})
